/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC, useContext} from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { Logout, AuthPage} from '../modules/auth'
import App from '../App'
import { UserContext } from '../../contextStore'
import Meeting from '../pages/ZoomMeeting/ZoomComponent'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env

const AppRoutes: FC = () => {
  const {isLoggedIn,userDetail} = useContext(UserContext)
  
  return (
      <BrowserRouter basename={PUBLIC_URL}>
        <Routes>
          <Route element={<App />}>
            <Route path='error/*' element={<ErrorsPage />} />
            <Route path='logout' element={<Logout />} />
            { isLoggedIn ? (
              <>
                <Route path='/*' element={<PrivateRoutes />} />
                <Route index element={<Navigate to='/dashboard' />} />
                <Route path={"zoom-meeting/:id"} element={<Meeting play />} />
                <Route path={"zoom-meeting/:id/:pwd"} element={<Meeting play />} />
              </>
            ) : (
              <>
                <Route path='auth/*' element={<AuthPage />} />
                <Route path='*' element={<Navigate to='/auth' />} />
              </>
            )}
          </Route>
        </Routes>
        {/* <Route path='meeting' element={<Zoom />} /> */}
      </BrowserRouter >
  )
}

export { AppRoutes }
